<template lang="html">
  <div>
    <div class="col-md-12">
      <div clas="form-group" v-show="show_selector">
        <label>Seleccione el campeonato a configurar</label>
        <select v-model="id" class="form-control" @change="selectChampionship">
          <option></option>
          <option v-for="championship in championships" value="{{championship.id}}">
            {{championship.name | capitalize}}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import configure from '../../configure'
import * as actions from '../../vuex/actions'

export default {
  vuex: {
    actions: actions
  },
  data: function () {
    return {
      championships: []
    }
  },
  ready: function () {
    this.fetchChampionships()
  },
  computed: {
    show_selector() {
      if(this.championships.length > 0) {
        return true
      }
      return false
    }
  },
  methods: {
    fetchChampionships() {
      this.$progress.start()
      this.$http.get(
        configure.api_url + 'championships'
      ).then((response) => {
        this.championships = response.data
        this.$progress.finish()
      }, (error) => {
        alert('Error fetching championship')
        this.$progress.failed()
      });
    },
    selectChampionship() {
      this.$progress.start()
      this.$http.get(
        configure.api_url + 'championships/' + this.id
      ).then((response) => {
        let championship = response.data;
        this.setConfigChampionship(championship);
        this.setConfigDates(championship.dates);
        this.setConfigCourses(championship.courses);
        this.setConfigCategories(championship.categories);
        this.loadConfigRegistrations();
        this.fetchConfigAwards();
        this.$progress.finish()
      }, (error) => {
        this.setLoading(false);
        alert('Error getting championship');
        this.$progress.failed()
      })
    }
  }
}
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** ChampionshipSelector.vue?15a21d3a
 **/